import Link from "next/link";
import { FC, PropsWithChildren } from "react";

type Props = {
  src: string;
  alt: string;
  href: string;
  size?: number;
};

const SnsItem: FC<PropsWithChildren<Props>> = ({
  src,
  href,
  alt,
  size = 80,
}): JSX.Element => {
  return (
    <Link
      className="bg-black rounded-full p-12"
      style={{
        width: size,
        height: size,
      }}
      href={href}
      target="_blank"
    >
      <img className="w-[96%] h-auto" src={src} alt={alt} />
    </Link>
  );
};
export default SnsItem;
